// extracted by mini-css-extract-plugin
module.exports = {"Icon":"VideoContextMenu_Icon__7c8OD"};